import React from "react";

import { Props } from "./types";

function CreateFolderIcon({ className }: Props) {
  return (
    <svg viewBox="0 0 19.197 15.598" className={className}>
      <path
        d="M13.369,8.184l-2.4-2.4h-8.4v15.6h19.2V8.184h-8.4Zm2.4,8.4h-2.4v2.4h-2.4v-2.4H8.57v-2.4h2.4v-2.4h2.4v2.4h2.4Z"
        transform="translate(-2.571 -5.784)"
      />
    </svg>
  );
}

export { CreateFolderIcon };
